import { AnyAction } from 'redux';
import { connect } from 'react-redux';
import { ThunkDispatch } from 'redux-thunk';

import { RiskJudge } from '../components';
import {
  RiskJudgeState,
  postRiskJudge,
  clearRiskJudgeMessages,
  clearRiskJudge,
} from '../modules/riskJudge';
import { UploadForRiskJudgeState } from '../modules/uploadForRiskJudge';
import { goUpalodRiskJudgePage } from '../modules/pages';

export function mapStateToProps(state: {
  uploadForRiskJudge: UploadForRiskJudgeState,
  riskJudge: RiskJudgeState,
}) {
  const { riskJudge, messages } = state.riskJudge;
  const { files } = state.uploadForRiskJudge;
  return {
    files,
    riskJudge,
    messages,
  };
}

export function mapDispatchToProps(dispatch: ThunkDispatch<any, any, AnyAction>) {
  return {
    doRiskjudge: (id: number) => dispatch(postRiskJudge(id)),
    clearRiskJudgeMessages: () => dispatch(clearRiskJudgeMessages()),
    goUpalodRiskJudgePage: () => {
      dispatch(clearRiskJudge());
      dispatch(goUpalodRiskJudgePage());
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(RiskJudge);



// WEBPACK FOOTER //
// ./src/containers/RiskJudge.tsx